<template>
  <div class="dem-edi-pro-dev-form simplificado" :data-time="time">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <!-- SETA O BOTÃO PARA ADICIONAR NOVOS ITENS NA DEVOLUÇÃO -->
      <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick="demEdiProFormDevMostrarOcultarDialog">Adicionar mais itens nesta devolução</App-Button>

      <!-- SETA A DIALOG PARA ADICIONAR NOVOS PRODUTOS -->
      <RF-Dialog :data-time="time" v-if="dialog === true && demanda !== null"
      :cpntLargura='"700px"'
      :cpntStatus="''"
      :cpntOnFecharDialog='demEdiProFormDevMostrarOcultarDialog'>
      <template slot='titulo'>      
        <div class="dem-nova-titulo">
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          Adicionar itens na devolução
        </div>
      </template>

      <template slot='conteudo'>
        <App-Demanda-Nova-Devolucao-Quantidade-Devolver
        :cpntDemanda="cpntDemanda"
        :cpntDemandaId="cpntDemandaId"
        :cpntDemandaRefId="demanda.dem_ref"
        :cpntPDocFreTp="demanda.p_doc.p_doc_fre_tp"

        :cpntDemDevAtualizarDadosDemanda="(demandaId, callback) => { demEdiProFormDevAtualizarDemandaReferencia(callback) }"
        ref="pro_qtde"
        ></App-Demanda-Nova-Devolucao-Quantidade-Devolver>
      </template>

      <template slot='rodape-right'>
        <div class="dem-edi-pro-dev-form-rodape">
          <App-Button
            :cpntStatus='botoes.cancelar.status' 
            :cpntId='botoes.cancelar.id' 
            :cpntTexto='botoes.cancelar.texto' 
            :cpntClass='botoes.cancelar.class'
            :cpntMostrar='botoes.salvar.mostrar'
            :cpntTabIndex='botoes.cancelar.tabIndex'
            @onClick='botoes.cancelar.onClick'
          ></App-Button>

          <App-Button
            :cpntStatus='botoes.salvar.status' 
            :cpntId='botoes.salvar.id' 
            :cpntTexto='botoes.salvar.texto' 
            :cpntClass='botoes.salvar.class'
            :cpntMostrar='botoes.salvar.mostrar'
            :cpntTabIndex='botoes.salvar.tabIndex'
            @onClick='botoes.salvar.onClick'
          ></App-Button>
        </div>
      </template>
      </RF-Dialog>
    </template>
  </div>
</template>

<style scoped>
  .dem-edi-pro-dev-form {
    padding: 8px 12px 13px 12px;
    background: #efefef;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
    max-width: 100%;
  }
    .dem-edi-pro-dev-form.simplificado {
      max-width: 370px;
    }
    .dem-edi-pro-dev-form > button {
      width: 100%;
    }

  .dem-edi-pro-dev-form-rodape {
    text-align: right;
  }
    .dem-edi-pro-dev-form-rodape > button {
      margin: 0px 4px;
    }
    .dem-edi-pro-dev-form-rodape > button:last-child {
      margin-right: 0px;
    }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      }
    },
    components: {
      'App-Demanda-Nova-Devolucao-Quantidade-Devolver': () => import('@/components/demanda/Devolucao/Demanda-Nova-Devolucao-Quantidade-Devolver.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        dialog: false,
        demanda: null,
        botoes: {
          cancelar: {
            status: '',
            tabIndex: 6010002,
            id: 'dem-edi-pro-dev-form-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.demEdiProFormDevMostrarOcultarDialog() }
          },
          salvar: {
            status: '',
            tabIndex: 6010001,
            id: 'dem-edi-pro-dev-form-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.demEdiProFormDevSalvar() }
          }
        }
      }
    },
    mounted: function () {
      this.demEdiProFormDevIniciar()
    },
    methods: {
      demEdiProFormDevIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.demEdiProFormDevSetarStatusGeral('')
      },
      demEdiProFormDevMostrarOcultarDialog: function () {
        // SETA SE DEVE OU NÃO MOSTRAR A DIALOG
        this.dialog = !this.dialog

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // BUSCA OS DADOS DA DEVOLUÇÃO
        if (this.dialog === true) {
          this.demEdiProFormDevAtualizarDemandaReferencia()
        }
      },
      demEdiProFormDevSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProFormDevSalvar: function () {
        // MANDA SALVAR OS ITENS NA TELA
        this.$refs.pro_qtde.demDevQtdeProInserirItens(() => {
          this.demDevCreVerificarSugestaoNatOpe(() => {
            // TRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

            // MANDA ATUALIZAR A TABELA
            this.$emit('DEMANDA_UPDATE_TABELA')

            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
              // FECHA A DIALOG
              this.demEdiProFormDevMostrarOcultarDialog()
  
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
            })
          })
        })
      },
      demEdiProFormDevAtualizarDemandaReferencia: function (callback = null) {
        // INICIA A VARIAVEL DE ROTA
        var router = ''

        // INICIA A QUERY PARA BUSCAR OS DADOS DA DEVOLUÇÃO
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          passo: null,
          id_con_dev_credito: null,
          dem_ref: { j: {
            p_doc_docs: { j: {
              tpAmb: null,
              DocModelo: null,
              DocNumero: null,
              DocSerie: null,
              DocDhAut: null,
              DocDhAutFuso: null,
              DocChaAcesso: null
              // SitCodigo: null,
              // SitCodigo_log: null,
              // email_last_at: null,
              // email_json_log: null
            } },
          } },
          // clu: null,
          // cms_status: null,
          // cod_venda: null,
          data: { a: 'created_at_ptbr' },
          // dt_ent: null,
          id_con: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, pj_sn: null, id_estado: null, status: null, id_cms: { j: { nome: null } } } },
          j_p_doc_fin_ref_manual: null,
          // km: null,
          // n_p: null,
          obs: null,
          obs_emp: null,
          obs_nf_pro: null,
          obs_nf_pro_separado: null,
          // obs_producao: null,
          p_doc_ca: null,
          p_doc_dh_sai_ent: null,
          // p_doc_docs: { j: {
          //   tpAmb: null,
          //   DocModelo: null,
          //   DocNumero: null,
          //   DocSerie: null,
          //   DocDhAut: null,
          //   DocDhAutFuso: null,
          //   // DocChaAcesso: null,
          //   // SitCodigo: null,
          //   // SitCodigo_log: null
          //   // email_last_at: null,
          //   // email_json_log: null
          // } },
          p_doc_emi: null,
          p_doc_fin: null,
          p_doc_fin_ref_compra: null,
          p_doc_fre_id: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, status: null } },
          p_doc_fre_placa: null,
          p_doc_fre_placa_uf: null,
          p_doc_fre_tp: null,
          p_doc_fre_vol: null,
          // p_id_ven_cfg_intermediador: { j: { nome: null, cnpj: null, usu_intermediador: null } },
          p_doc_icms_aa: null,
          p_doc_ind_pres: null,
          p_doc_n: null,
          p_doc_nat_ope: null,
          p_doc_od: null,
          p_doc_ope: null,
          p_doc_ret_prev_a: null,
          p_doc_s: null,
          p_doc_tp: null,
          p_doc_tpAmb: null,
          p_doc_vf: null,
          p_doc_vs: null,
          p_mostrar: null,
          // pdv_senha: null,
          // pdv_status: null,
          // s_doc_cv: null,
          // s_doc_des: null,
          // s_doc_emi: null,
          // s_doc_n: null,
          // s_doc_ret: null,
          // s_doc_s: null,
          // s_doc_tp: null,
          // s_mostrar: null,
          // sta_producao: null,
          status: null,
          // status_fin: null,
          updated_user: { j: { usuario: null } },
          vencimento: null
        }

        // SETA OS FIELDS VIRTUAIS QUE DEVE RETORNAR
        queryGet.field_virtual = [ 'total', 'p_doc_des_novo' ]

        // RETORNA PARA TELA DE GERENCIAR
        switch (this.cpntDemanda) {
          case 'dev_cliente':
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/demanda/dem-dev-cliente/get'

            // ADICIONA OS CAMPOS DA DEMANDA
            queryGet.field = Object.assign(queryGet.field, {
              dem_dev_cliente: null
            })

            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [
              { f: 'status', o: '<>', v: '3' },
              { f: 'dem_dev_cliente', o: '=', v: this.cpntDemandaId }
            ] }
            break

          case 'dev_fornecedor':
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/demanda/dem-dev-fornecedor/get'

            // ADICIONA OS CAMPOS DA DEMANDA
            queryGet.field = Object.assign(queryGet.field, {
              dem_dev_fornecedor: null
            })

            // SETA O WHERE QUE DEVE REALIZAR
            queryGet.where = { aAnd: [
              { f: 'status', o: '<>', v: '3' },
              { f: 'dem_dev_fornecedor', o: '=', v: this.cpntDemandaId }
            ] }
            break
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
          if (retorno.data.length === 0) {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.msgWarn('WEB [406]: Não foi possivel identificar os dados a demanda (' + this.cpntDemandaId + ') solicitada.', 'warning')

            // RETORNA PARA TELA DE GERENCIAR
            switch (this.cpntDemanda) {
              case 'dev_cliente':
                this.$router.push({ name: 'dev_cliente_gerenciar' })
                break

              case 'dev_fornecedor':
                this.$router.push({ name: 'dev_fornecedor_gerenciar' })
                break
            }
          } else {
            // FAZ A BUSCA DO VOLUME
            this.demDevBuscarVolumes(retorno.data[0], (retorno) => {
              // SETA OS VALORES
              retorno = Object.assign(retorno, { p_doc: {
                estoque: retorno.virtual_estoque_status,
                p_doc_tp: { value: retorno.p_doc_tp, options: [] },
                p_doc_ope: retorno.p_doc_ope,
                p_doc_nat_ope: retorno.p_doc_nat_ope,
                p_doc_fin: retorno.p_doc_fin,
                j_p_doc_ref_ca: retorno.j_p_doc_fin_ref_manual,
                p_doc_ind_pres: retorno.p_doc_ind_pres,
                p_doc_fre_tp: retorno.p_doc_fre_tp,
                p_doc_fre_placa_uf: retorno.p_doc_fre_placa_uf,
                p_doc_fre_placa: retorno.p_doc_fre_placa,
                p_doc_fre_volumes: retorno.p_doc_fre_volumes,
                p_doc_ret_prev_a: ([ '', null, undefined ].indexOf(retorno.p_doc_ret_prev_a) === -1 ? retorno.p_doc_ret_prev_a : retorno.p_doc_ret_prev_a),
                p_doc_dh_sai_ent: retorno.p_doc_dh_sai_ent_ptbr,
                p_doc_docs: retorno.p_doc_docs,
                doc_fiscal: {
                  id: retorno.p_doc_docs,
                  tpAmb: retorno.p_doc_docs_tpAmb,
                  DocModelo: retorno.p_doc_docs_DocModelo,
                  DocNumero: retorno.p_doc_docs_DocNumero,
                  DocSerie: retorno.p_doc_docs_DocSerie,
                  DocDhAut: retorno.p_doc_docs_DocDhAut,
                  DocDhAutFuso: retorno.p_doc_docs_DocDhAutFuso,
                  DocChaAcesso: retorno.p_doc_docs_DocChaAcesso,
                  SitCodigo: retorno.p_doc_docs_SitCodigo,
                  SitCodigo_log: retorno.p_doc_docs_SitCodigo_log,
                  email_last_at: retorno.p_doc_docs_email_last_at,
                  email_json_log: retorno.p_doc_docs_email_json_log
                },
                p_doc_fre_id: {
                  id_con: retorno.p_doc_fre_id,
                  id_con_cnpj_cpf: retorno.p_doc_fre_id_cnpj_cpf,
                  id_con_empresa: retorno.p_doc_fre_id_empresa,
                  id_con_nome: retorno.p_doc_fre_id_nome,
                  id_con_status: retorno.p_doc_fre_id_status,
                },
                p_id_ven_cfg_intermediador: {
                  id: retorno.p_id_ven_cfg_intermediador,
                  nome: retorno.p_id_ven_cfg_intermediador_nome,
                  cnpj: retorno.p_id_ven_cfg_intermediador_cnpj,
                  _cnpj: (([ '', null, undefined ].indexOf(retorno.p_id_ven_cfg_intermediador_cnpj) === -1 && retorno.p_id_ven_cfg_intermediador_cnpj.length === 14) ? retorno.p_id_ven_cfg_intermediador_cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5') : ''),
                  usu_intermediador: retorno.p_id_ven_cfg_intermediador_usu_intermediador
                },
                cce: [ '', null, undefined ].indexOf(retorno.virtual_p_doc_cce) === -1 ? retorno.virtual_p_doc_cce : null, 
                acoes: Object.assign({
                  cancelar: '0',
                  consultar: '0',
                  danfe: '0',
                  emitir: '1',
                  inutilizar: '0',
                  reemitir: '0',
                  rejeicao: '0',
                  salvar: '0',
                  contingencia: '0'
                }, retorno.virtual_p_doc_acao),
                p_doc_ca: retorno.p_doc_ca,
                p_doc_emi: retorno.p_doc_emi_ptbr,
                p_doc_n: retorno.p_doc_n,
                p_doc_s: retorno.p_doc_s,
                p_doc_des: ([ '', null, undefined ].indexOf(retorno.virtual_p_doc_des_novo) === -1 ? retorno.virtual_p_doc_des_novo : { global_select: 'porcentagem', global_porcentagem: '0', global_valor: '0' }),
                p_doc_od: retorno.p_doc_od,
                p_doc_vf: retorno.p_doc_vf,
                p_doc_vs: retorno.p_doc_vs
              } })
    
              // FORMATA O RECEBIMENTO DOS VALORES
              retorno.virtual_total = { produto: retorno.virtual_total, geral: retorno.virtual_total }
  
              // VERIFICA SE TEM A CHAVE DE VALORES
              if ([ '', null, undefined ].indexOf(retorno.virtual_total) === -1) {
                // SETA O VALOR INICIAL DAS CHAVES
                var vetorIni = {
                  produto: {
                    creDevolucao: 0.00,
                    _creDevolucao: '0,00',
                    total: 0.00,
                    _total: '0,00',
                    item: 0,
                    frete: 0.00,
                    _frete: '0,00',
                    seguro: 0.00,
                    _seguro: '0,00',
                    desconto: 0.00,
                    _desconto: '0,00',
                    oda: 0.00,
                    _oda: '0,00',
                    liquido: 0.00,
                    _liquido: '0,00'
                  },
                  geral: {
                    total: 0.00,
                    _total: '0,00',
                    liquido: 0.00,
                    _liquido: '0,00',
                    taxa: 0.00,
                    _taxa: '0,00',
                    desconto: 0.00,
                    _desconto: '0,00',
                    retencao: 0.00,
                    _retencao: '0,00',
                    creDevolucao: 0.00,
                    _creDevolucao: '0,00'
                  }
                }
  
                // RODA O FOR FORMATANDO OS VALORES
                for (var indexT in retorno.virtual_total) {
                  // COLOCA AS CHAVES INICIAIS
                  retorno.virtual_total[indexT] = Object.assign(vetorIni[indexT], retorno.virtual_total[indexT])
  
                  // RODA O FOR FORMATANDO OS VALORES
                  for (var indexC in retorno.virtual_total[indexT]) {
                    switch (indexC) {
                      case 'creDevolucao':
                      case 'desconto':
                      case 'liquido':
                      case 'retencao':
                      case 'frete':
                      case 'oda':
                      case 'seguro':
                      case 'total':
                      case 'taxa':
                        retorno.virtual_total[indexT]['_' + indexC] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.virtual_total[indexT][indexC])
                        break
                    }
                  }
                }
              }
  
              // CONVERTE O VALOR RECEBIDO
              if (retorno.dem !== undefined && retorno.dem.dem_obs_nf_separado !== undefined) {
                retorno.dem.dem_obs_nf_separado = retorno.dem.dem_obs_nf_separado === 's'
              }
  
              // VERIFICA SE TEM UMA REFERENCIA DE NOTA
              if (retorno.p_doc !== undefined) {
                if (retorno.p_doc.j_p_doc_ref_ca !== undefined) {
                  retorno.p_doc.j_p_doc_ref_ca = [ '', null ].indexOf(retorno.p_doc.j_p_doc_ref_ca) !== -1 ? null : JSON.parse(retorno.p_doc.j_p_doc_ref_ca)
                }
    
                // VERIFICA SE TEM UMA REFERENCIA DE NOTA
                if (retorno.p_doc.p_doc_fre_volumes !== undefined) {
                  retorno.p_doc.p_doc_fre_volumes = [ '', null ].indexOf(retorno.p_doc.p_doc_fre_volumes) !== -1 ? null : retorno.p_doc.p_doc_fre_volumes
                }
  
                // VERIFICA SE TEM UMA REFERENCIA DE NOTA
                if (retorno.p_doc.p_doc_ret_prev_a !== undefined) {
                  retorno.p_doc.p_doc_ret_prev_a = [ '', null ].indexOf(retorno.p_doc.p_doc_ret_prev_a) !== -1 ? null : retorno.p_doc.p_doc_ret_prev_a
                }
  
                // VERIFICA SE TEM UMA REFERENCIA DE NOTA
                if (retorno.p_doc.p_doc_dh_sai_ent !== undefined) {
                  retorno.p_doc.p_doc_dh_sai_ent = [ '', null ].indexOf(retorno.p_doc.p_doc_dh_sai_ent) !== -1 ? null : retorno.p_doc.p_doc_dh_sai_ent
                }
              }
  
              // SETA OS DADOS DA DEMANDA
              this.demanda = retorno             
              
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // EXECUTA O CALLBACK RECEBIDO
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            })
          }
        }, this.demEdiProFormDevSetarStatusGeral)
      },
      demDevBuscarVolumes: function (vetor, callback) {
        if (vetor.p_doc_fre_vol === '1') {
          // INICIA A QUERY A SER EXECUTADA
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field = {
            id: null,
            p_doc_fre_vol_esp: null,
            p_doc_fre_vol_mar: null,
            p_doc_fre_vol_num: null,
            p_doc_fre_vol_pb: null,
            p_doc_fre_vol_pl: null,
            p_doc_fre_vol_qtde: null
          }

          // VERIFICA O TIPO DE DEMANDA QUE DEVE BUSCAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              queryGet.where = { f: 'dem_dev_cliente', o: '=', v: this.cpntDemandaId }
              break
          }

          // REALIZA A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/demanda/dem-dev-cliente/dem-df-volume/get', 'POST', queryGet, (retorno) => {
            // SETA OS VOLUMES ENCONTRADOS
            vetor.p_doc_fre_volumes = retorno.data

            // RETORNA O VALOR MONTADO
            callback(vetor)
          }, this.demEdiProFormDevSetarStatusGeral)
        } else {
          callback(vetor)
        }
      },
      demDevCreVerificarSugestaoNatOpe: function (callback) {
        if (this.demanda.p_doc.p_doc_tp.value === 'NFe' && [ '', null, undefined ].indexOf(this.demanda.p_doc.p_doc_nat_ope) !== -1) {
          // SETA O NOME DA ROTA QUE DEVE CHAMAR
          var router = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/df-sug-nat-operacao/get/dem_dev_cliente/'
              break
          
            case 'venda':
              router = '/venda/produto/df/sug-nat-ope/get/'
              break
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI(router, 'GET', this.cpntDemandaId, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.data) === -1) {
              // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
              const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA
    
              // PEGA A CHAVE REFERENCIA
              var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

              // INICIA O FORMULARIO QUE SERÁ APRESENTADO
              var formData = {}

              // SETA O NUMERO DA DEMANDA
              formData[chaveD] = this.cpntDemandaId

              // SETA O ID DO NOVO CONTATO
              formData.p_doc_nat_ope = retorno.data

              // CONVERTE O VALOR PARA LOT
              formData = { lot: [ formData ] }

              // FAZ A BUSCA DOS DADOS
              this.$store.state.comunicaAPI('/demanda/dem-dev-cliente/p-doc-nat-ope', 'PUT', formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200', message: retorno.message })

                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.demDevCreTratarValidacao(retorno.message, retorno.code)
                } else {
                  callback()
                }
              }, this.demEdiProFormDevSetarStatusGeral, (apiValid, apiStatus) => { this.demDevCreTratarValidacao(apiValid, apiStatus) })
            }
          }, this.demEdiProFormDevSetarStatusGeral, (apiValid, apiStatus) => { this.demDevCreTratarValidacao(apiValid, apiStatus) })
        } else {
          callback()
        }
      }
    }
  }
</script>
